import { Badge } from "@/components/ui/badge";

interface XactimateCodeDisplayProps {
  cat?: string;
  selCode?: string;
}
export const XactimateCodeDisplay = ({ cat, selCode }: XactimateCodeDisplayProps) => {
  return (
    <div className="my-2 flex flex-row items-center gap-2">
      <p className="text-sm font-medium">CAT: </p>
      <Badge variant="cat">{cat}</Badge>
      <p className="text-sm font-medium">SEL: </p>
      <Badge variant="sel">{selCode}</Badge>
    </div>
  );
};
